"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantConfigurationKeys = void 0;
exports.MerchantConfigurationKeys = [
    'allow_share_location',
    'acknowledge_flow_ui_config',
    'task_fields',
    'advance_configuration_enabled',
    'address_format',
    'alert_configurations',
    'alert_if_user_rated_below',
    'alerts_types',
    'allow_access_to_all_open_tasks',
    'allow_customer_fb_like',
    'allow_customer_find_me',
    'allow_cx_customer_cancellation',
    'allow_dispatcher_to_access_all_teams',
    'allow_dispatcher_to_access_task_price',
    'allow_dispatcher_to_edit_drivers',
    'allow_moving_tasks_to_planning_phase',
    'allow_offshift_drivers_to_be_assigned',
    'allow_rating',
    'allow_single_order_per_driver',
    'alternate_delivery_pin',
    'application_configurations',
    'application_merchant_configurations',
    'applications',
    'auto_dispatch',
    'auto_dispatch_optimization_method',
    'auto_dispatch_timeout',
    'auto_dispatch_timeout_per_driver',
    'auto_share_location',
    'average_delivery_time',
    'avoid_commercial_roads',
    'driver_administration_time_seconds',
    'cancel_undone_tasks_by_eod',
    'cash_out_flow_enabled',
    'settlement_enabled',
    'cash_out_template_name',
    'consumer_app_eta_display_method',
    'country_code',
    'custom_drivers_page_row_colors',
    'customer_fb_like_url',
    'cx_cancel_event_type',
    'cx_calendar_view_for_delivery_options',
    'cx_on_order_canceled_title',
    'dashboard_refresh_rate_secs',
    'debrief_flow_enabled',
    'default_estimate_duration_on_site_in_seconds',
    'default_inventory_time_on_site_seconds',
    'default_minutes_buffer_for_asap_orders',
    'default_minutes_buffer_for_scheduled_orders',
    'delivery_pin',
    'destination_pin',
    'distance_threshold',
    'driver_at_home_flow_options',
    'driver_preparation_time_seconds',
    'email_logo',
    'email_style_color',
    'enable_dashboard',
    'enable_dimension_editing_in_ui',
    'enable_future_tasks',
    'enable_kds',
    'enable_looping_alert_sound',
    'enable_map_overlays',
    'enable_planned_routes',
    'enable_reschedule_flow',
    'enable_shifts_actions',
    'enable_support',
    'enable_support_ticket_on_web',
    'enable_task_acknowledge_flow',
    'enable_task_cancellation',
    'enable_task_price',
    'enable_teams',
    'enable_user_types',
    'end_of_day_time',
    'eta_background_color',
    'eta_minutes_color',
    'eta_time_color',
    'eta_title_color',
    'extra_terms_and_conditions_url',
    'grab_future_timeout',
    'grab_mode',
    'grab_mode_alert_type',
    'grab_mode_radius',
    'grab_mode_timeout',
    'header_color',
    'history_fields',
    'initial_tasks_page_size',
    'inverse_header_color',
    'invoice_printed_copies',
    'language_code',
    'lat',
    'late_buffer',
    'lng',
    'logo',
    'logout_idle_admin_minutes',
    'logout_idle_dispatcher_minutes',
    'looping_alert_sound_type',
    'map_type',
    'max_distance_for_optimization_in_meters',
    'max_distance_from_home_to_task_km',
    'max_distance_to_not_report',
    'merchant_id',
    'merchant_mode',
    'minutes_until_first_wp_scheduled_at',
    'name',
    'number_of_retries_before_a_phone_call',
    'open_tasks_filter',
    'paid_google_maps_api',
    'phone_call_string',
    'planning_fields',
    'planning_phase_exists',
    'planning_phase_print_on_apply',
    'planning_phase_send_emails_to_drivers_on_apply',
    'preparation_flow_ui_config',
    'price_currency',
    'printer_type',
    'qr_login_flow_options',
    'reminder_timeout',
    'reply_to_shared_email',
    'run_batcher_on_grab_mode',
    'scan_code_unique',
    'secured_setup',
    'send_sms_to_first_way_point',
    'set_min_eta_by_time_window',
    'share_if_too_close',
    'sharing_mode',
    'send_shared_location_webhook_on_contacts_missing',
    'show_bringg_logo',
    'show_eta_to_home',
    'show_new_reports',
    'soft_csv_import',
    'sound_on_new_order',
    'support_parcel_shop_last_mile',
    'task_fields',
    'task_alert_fields',
    'driver_alert_fields',
    'optimization_alert_fields',
    'task_forwarding_enabled',
    'task_invoice_template_name',
    'task_window_bottom_buffer_minutes',
    'task_window_top_buffer_minutes',
    'tasks_page_size',
    'the_batcher',
    'time_to_remind_before_start_task',
    'tip_driver_enabled',
    'unique_external_id_rule',
    'update_location_max_idle_time',
    'use_coc',
    'use_time_windows',
    'voice_reminder_frequency',
    'voice_reminder_text',
    'windows',
    'windows_mode',
    'enable_chat',
    'inherit_team_from_group_team',
    'hour_format',
    'dispatch_filter_limit',
    'set_duplicated_order_in_planning',
    'dynamic_capacity_values_mode',
    'customer_verification_pin_code_flow',
    'unique_customer_fields',
    'unique_inventory_fields',
    'unique_user_fields',
    'default_dispatcher_welcome_url_id',
    'localize_task_timezones_by_teams',
    'driver_unavailable_toggle_enabled',
    'enable_waypoint_timezone'
];
//# sourceMappingURL=MerchantConfiguration.consts.js.map